/**
 * 环境变量
 */
/** 是否开启问诊图片必传校验，默认关闭 */
export const IS_INQUIRY_IMG_NECESSARY =
  process.env.MED_IS_INQUIRY_IMG_NECESSARY === 'true';
/** 是否开启开药门诊图片必传校验 */
export const IS_OUTPATIENT_IMG_NECESSARY =
  process.env.MED_IS_OUTPATIENT_IMG_NECESSARY === 'true';
/** 是否开启医带患图片必传校验 */
export const IS_FOLLOWUP_IMG_NECESSARY =
  process.env.MED_IS_FOLLOWUP_IMG_NECESSARY === 'true';
/** 创建订单时优惠券是否能使用开关 */
export const PROMOTION_SWITCH = process.env.MED_PROMOTION_SWITCH === 'true';
// 微信公众号app_ID
export const WX_APPID = process.env.MED_APP_ID;
// 药店渠道id,药房网
export const DRUG_STORE_CHANNEL_ID_YFW = Number(
  process.env.MED_DRUG_STORE_CHANNEL_ID_YFW
);
export const DRUG_STORE_CHANNEL_ID = Number(
  process.env.MED_DRUG_STORE_CHANNEL_ID
)